<template>
  <section class="OneTimeOrderList">
    <div class="OneTimeOrderList_header row no-gutters">
      <div class="col-3 text-left">
        <h6 class="field-title">
          {{ $t('subscription_details.replenishment.oneTimeOrders.fieldTitle.description', 'Description') }}
        </h6>
      </div>
      <div class="col-1">
        <h6 class="field-title">
          {{ $t('subscription_details.replenishment.oneTimeOrders.fieldTitle.QTY', 'QTY') }}
        </h6>
      </div>
      <div class="col-2">
        <h6 class="field-title">
          {{ $t('subscription_details.replenishment.oneTimeOrders.fieldTitle.price', 'Price') }}
        </h6>
      </div>
      <div class="col-3">
        <h6 class="field-title">
          {{ $t('subscription_details.replenishment.oneTimeOrders.fieldTitle.orderDate', 'Order Date') }}
        </h6>
      </div>
      <div class="col-3">
        <h6 class="field-title">
          {{ $t('subscription_details.replenishment.oneTimeOrders.fieldTitle.shippingDate', 'Shipping Date') }}
        </h6>
      </div>
    </div>

    <div
      class="OneTimeOrderList_item row no-gutters"
      v-for="(oneTimeOrder, index) in subscriptionOneTimeOrders"
      :key="index"
    >
      <div class="col-3 text-left">
        <span class="field-info text-break">
          {{ oneTimeOrder.description }}
        </span>
      </div>
      <div class="col-1">
        <span class="field-info">
          {{ oneTimeOrder.quantity }}
        </span>
      </div>
      <div class="col-2">
        <span class="field-info">
          {{ oneTimeOrder.price | formatCurrency }}
        </span>
      </div>
      <div class="col-3">
        <span class="field-info">
          {{ oneTimeOrder.orderDate | formatLocalDate }}
        </span>
      </div>
      <div class="col-3">
        <span class="field-info">
          {{ oneTimeOrder.shippingDate | formatLocalDate }}
        </span>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'replenishment-one-time-order-list',

    props: {
      subscriptionOneTimeOrders: {
        type: Array,
        default () {
          return []
        }
      }
    }
  }
</script>

<style lang="scss">
  .OneTimeOrderList {
    color: $blue;

    &_header,
    &_item {
      display: flex;
      align-items: center;
      margin-bottom: .1rem;
      text-align: center;
    }

    &_header {
      .field-title {
        font-size: .13rem;
      }
    }

    &_item {
      &:last-of-type {
        margin-bottom: 0;
      }

      .field-info {
        font-size: .13rem;
      }
    }
  }
</style>
